import React from "react";
import "./about.css";
import ME from "../../assets/me-about.png";
import { FaAward } from "react-icons/fa";
import { HiUsers } from "react-icons/hi";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { RiRefund2Fill } from "react-icons/ri";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="about me image" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>5+ Years Working</small>
            </article>
            <article className="about__card">
              <HiUsers className="about__icon" />
              <h5>Clients</h5>
              <small>150+ WorldWide</small>
            </article>
            <article className="about__card">
              <AiOutlineFundProjectionScreen className="about__icon" />
              <h5>Projects</h5>
              <small>150+ Completed Projects & Features</small>
            </article>
            <article className="about__card">
              <RiRefund2Fill className="about__icon" />
              <h5>ROI</h5>
              <small>30%+ In Profits On Average</small>
            </article>
          </div>
          <p>
            I worked with multiple clients and developers on many multi-levelled
            projects, I've proven to be a leader when needed to be and have
            gathered a lot of experience from many wonderful people throughout
            my journey, I love this field and I take a lot of pride in my work;
            if I don't like it, it will get corrected, or else I wouldn't be
            able to sleep at night. I have proven high ROI on all my projects, I
            always offer quality services at competitive prices, and I'm always
            looking forward to what opportunities the future brings me.
          </p>

          <a href="#contact" className="btn btn-primary">
            Message Me
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
